module.exports = __webpack_public_path__ + "static/campaign-meta-image-318ec81a1d57bf4041dca81c90c3e58a.jpg";